<div class="container">
  @for (sectionTitleContent of sectionTitle; track sectionTitleContent) {
    <div class="section-title">
      <span class="sub-title"><img src="assets/img/star-icon.png" alt="image"> {{sectionTitleContent.subTitle}}</span>
      <h2>{{sectionTitleContent.title}}</h2>
      <p>{{sectionTitleContent.paragraphText}}</p>
    </div>
  }

  <div class="row" style="justify-content: center;">
    @for (scientistBoxContent of singleScientistBox; track scientistBoxContent) {
      <div class="col-lg-3 col-sm-6 col-md-6">
        <div class="single-scientist-box">
          <div class="image">
            @if (scientistBoxContent.img === 'assets/img/scientist/rashid-profile-pic.jpg') {
              <img style="height: 336px;" [src]="scientistBoxContent.img" [alt]="scientistBoxContent.title + ', ' + scientistBoxContent.designation">
            }
            @if (scientistBoxContent.img !== 'assets/img/scientist/rashid-profile-pic.jpg') {
              <img [src]="scientistBoxContent.img" [alt]="scientistBoxContent.title + ', ' + scientistBoxContent.designation">
            }
          </div>
          <div class="content">
            <h3>{{scientistBoxContent.title}}</h3>
            <span>{{scientistBoxContent.designation}}</span>
            <ul class="social">
              <!-- <li><a href="{{scientistBoxContent.facebookLink}}" class="d-block" target="_blank"><i class='{{scientistBoxContent.facebookIcon}}'></i></a></li>
              <li><a href="{{scientistBoxContent.twitterLink}}" class="d-block" target="_blank"><i class='{{scientistBoxContent.twitterIcon}}'></i></a></li> -->
              <li><a href="{{scientistBoxContent.githubLink}}" class="d-block" target="_blank"><i class='{{scientistBoxContent.githubIcon}}'></i></a></li>
              <li><a href="{{scientistBoxContent.linkedinLink}}" class="d-block" target="_blank"><i class='{{scientistBoxContent.linkedinIcon}}'></i></a></li>
            </ul>
          </div>
        </div>
      </div>
    }
  </div>
</div>